import { makeSearch } from "../../UI/Search/Search";
import PersonTypeService from "../../../Services/PersonType.service";
const makeSearchArgs = {
    loadOptions: (search, options) => PersonTypeService.searchAll({ query: search }),
    label: "name",
    value: "id",
};
export const PersonTypeSearch = makeSearch(makeSearchArgs);
